"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function generateOutfile(_type, _clientName, keyValuePairs) {
  return "" + keyValuePairs;
}

exports["default"] = generateOutfile;